import { DotOutline } from "@phosphor-icons/react";
import {
	ANSWER_SOURCE,
	getDisplayableDocuments,
	TEDCApplicant,
	useEDCFlow,
	validateApplicantDocuments,
	VALIDATION_STATUS
} from "@smvtech/x-flux";
import { getFullName, isDummyTravellerName } from "../../../helper";
import { useMemo } from "react";

const TravellerHeader = ({ activeApplicantData }: { activeApplicantData: TEDCApplicant }) => {
	const documents = useMemo(
		() =>
			getDisplayableDocuments(activeApplicantData.questions, [ANSWER_SOURCE.USER_INPUT, ANSWER_SOURCE.DOCUMENT]),
		[activeApplicantData.questions]
	);
	const validatedDocuments = useMemo(
		() => validateApplicantDocuments(activeApplicantData, [ANSWER_SOURCE.USER_INPUT, ANSWER_SOURCE.DOCUMENT]),
		[activeApplicantData]
	);

	const documentProgress = useMemo(() => {
		const total = documents.length;
		const uncompleted = validatedDocuments.filter((item) => {
			const status = item.validationResult?.status;
			return status === VALIDATION_STATUS.UNFIXABLE || status === VALIDATION_STATUS.MISSING;
		}).length;
		const completed = total - uncompleted;
		const percentage = total > 0 ? (completed / total) * 100 : 0;
		return { total, completed, percentage };
	}, [documents.length, validatedDocuments]);

	const travellerName = useMemo(() => {
		return getFullName(
			activeApplicantData.traveller.first_name,
			activeApplicantData.traveller.middle_name,
			activeApplicantData.traveller.last_name
		);
	}, [activeApplicantData.traveller]);

	return (
		<>
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-1">
					<p className="text-[13px] text-gray-950 font-medium">{travellerName}</p>

					{!isDummyTravellerName(travellerName) && (
						<>
							<DotOutline className="size-3 text-gray-400" weight="fill" />
							<p className="text-[13px] text-gray-500 font-medium">
								{activeApplicantData.traveller.passport}
							</p>
						</>
					)}
				</div>

				<div className="flex items-center gap-16">
					<div className="flex items-center gap-2">
						<div className="h-2 w-32 rounded-full" style={{ backgroundColor: "#E0E7FF" }}>
							<div
								className="h-2 rounded-full transition-all duration-300"
								style={{
									width: `${documentProgress.percentage}%`,
									backgroundColor: "#4E46E2"
								}}
							/>
						</div>
						<p className="text-sm text-gray-600 whitespace-nowrap">
							{documentProgress.completed}/{documentProgress.total} submitted
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default TravellerHeader;

